import React from 'react'

const svgTag = `      
  <title>warranty-badge</title>
  <defs>
    <path d="M18.0323612,7.14527786 L10.0694445,15.1081945 L5.73152786,10.7823612 L4.02777786,12.4861112 L10.0694445,18.5277779 L19.7361112,8.86111119 L18.0323612,7.14527786 Z M12.4861112,0.402777858 C5.81611119,0.402777858 0.402777858,5.81611119 0.402777858,12.4861112 C0.402777858,19.1561112 5.81611119,24.5694445 12.4861112,24.5694445 C19.1561112,24.5694445 24.5694445,19.1561112 24.5694445,12.4861112 C24.5694445,5.81611119 19.1561112,0.402777858 12.4861112,0.402777858 Z M12.4861112,22.1527779 C7.14527786,22.1527779 2.81944452,17.8269445 2.81944452,12.4861112 C2.81944452,7.14527786 7.14527786,2.81944452 12.4861112,2.81944452 C17.8269445,2.81944452 22.1527779,7.14527786 22.1527779,12.4861112 C22.1527779,17.8269445 17.8269445,22.1527779 12.4861112,22.1527779 Z" id="path-1"></path>
  </defs>
  <g id="+60-days" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="return-confirmation---warranty-claim" transform="translate(-17.000000, -250.000000)">
      <g id="warranty-badge" transform="translate(17.000000, 250.000000)">
        <g id="warranty" fill="#333333">
          <path d="M27.2386103,4.51559185 C27.6838917,3.9557269 28.156892,4.07927851 28.2973325,4.80313143 L39.5544202,62.823952 C39.6585184,63.3604906 39.3229626,63.631471 38.8226252,63.4361108 L15.7933043,54.4441534 C14.2549365,53.8434871 12.753325,52.0447245 12.4397883,50.4287065 L6.79044144,21.311074 C6.58151019,20.2342091 7.2493202,19.0563418 8.2816867,18.6720139 C8.2816867,18.6720139 16.0509561,15.9174085 18.7022649,13.9736826 C21.3535737,12.0299566 27.2386103,4.51559185 27.2386103,4.51559185 Z" id="Path-5" transform="translate(23.077522, 33.648654) rotate(-349.000000) translate(-23.077522, -33.648654) "></path>
          <path d="M47.8428004,4.46080249 C48.307166,3.90516139 48.7956591,4.03223988 48.9361274,4.75622164 L60.1954396,62.7873697 C60.2995583,63.3240038 59.9682066,63.6004618 59.4490406,63.4024514 L36.0152161,54.4647711 C34.4734252,53.8767308 32.9689884,52.08797 32.6553897,50.4716644 L27.0049265,21.3488491 C26.795954,20.2717925 27.4638934,19.0937152 28.4964607,18.7093183 C28.4964607,18.7093183 36.2672414,15.9542186 38.9190654,14.0101452 C41.5708894,12.0660719 47.8428004,4.46080249 47.8428004,4.46080249 Z" id="Path-5-Copy-2" transform="translate(43.505256, 33.606878) scale(-1, 1) rotate(-349.000000) translate(-43.505256, -33.606878) "></path>
        </g>
        <g id="Group" transform="translate(19.000000, 20.000000)">
          <g id="ic/check_circle_outline" transform="translate(2.013889, 2.013889)">
            <mask id="mask-2" fill="white">
              <use xlink:href="#path-1"></use>
            </mask>
            <g id="Shape" fill-rule="nonzero"></g>
            <g id="Group" mask="url(#mask-2)">
              <g transform="translate(-2.013889, -2.013889)" id="🎨-Color">
                <rect id="Rectangle-Copy-10" fill="#FFFFFF" x="0" y="0" width="72.5" height="72.5"></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
`

const innerHTML = { __html: svgTag }
const WarrantyBadgeIcon = () => (
  <svg
    width="66px"
    height="67px"
    viewBox="0 0 66 67"
    version="1.1"
    dangerouslySetInnerHTML={innerHTML}
  />
)

export default WarrantyBadgeIcon
